enum TableName {
  WORK_QUEUE = "WORK_QUEUE",
  WORK_QUEUE_TREE = "WORK_QUEUE_TREE",
  PRODUCTION_HISTORY = "PRODUCTION_HISTORY",
  PRODUCTION_EVENT_HISTORY = "PRODUCTION_EVENT_HISTORY",
  UTIL_HISTORY = "UTIL_HISTORY",
  UTIL_EVENT_HISTORY = "UTIL_EVENT_HISTORY",
}
export default TableName;
